import { div } from "framer-motion/client";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import banner from "../../../assets/kangaroo/AboutBanner.png";
import SectionContainer from "../../../Homepage/SectionContainer";
import BreadCrumb from "../../../component/BreadCrumb/BreadCrumb";
import "../../CountryPage/country.css";
import guideImg from "../../../assets/kangaroo/guided.png";
import memberImg from "../../../assets/kangaroo/members.png";
import partnerImg from "../../../assets/kangaroo/partners.png";
import graduateImg from "../../../assets/kangaroo/graduates.png";
import officeImg from "../../../assets/kangaroo/office.png";
import experienceImg from "../../../assets/kangaroo/experience.png";
import "../About.css";
import house from "../../../assets/kangaroo/PurpleHouse2.png";
import { useLocation } from "react-router-dom";
import PageService from "../../../services/PageService";
import { imageBaseApi } from "../../../services/imageBaseApi";
import WhoweAreService from "../../../services/WhoWeAreService";
const AboutLanding = () => {
  const data = {
    guided: {
      number: "20,000+",
      desc: "STUDENTS GUIDED",
      color: "#7e1790",
      img: guideImg,
    },
    members: {
      number: "100+",
      desc: "TEAM MEMBERS",
      color: "#687c86",
      img: memberImg,
    },
    parterns: {
      number: "200+",
      desc: "GLOBAL PARTNER <br/> INSTITUTIONS",
      color: "#1900da",
      img: partnerImg,
    },
    graduates: {
      number: "8,000+",
      desc: "TEST PREPARATION <br/> GRADUATES",
      color: "#d70a84",
      img: graduateImg,
    },
    offices: {
      number: "14+",
      desc: "OFFICES ACROSS NEPAL & AUSTRALIA",
      color: "#ff4d1d",
      img: officeImg,
    },
    experience: {
      number: "19+",
      desc: "YEARS OF EXPERIENCE",
      color: "#7a0708",
      img: experienceImg,
    },
  };

  const location = useLocation();
  const path = location?.pathname?.split("/")?.filter(Boolean).pop();

  const [detailData, setDetailData] = useState();
  const fetchDetail = async () => {
    try {
      const response = await WhoweAreService.getbySlug(path);
      setDetailData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchDetail();
  }, [location]);

  const contents = detailData?.content
    .split("/newpara/")
    .map((text) => text.trim())
    .filter((text) => text.length > 0);
  const stats = Object.values(data);

  const renderContent = (htmlContent) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent;

    return Array.from(tempDiv.children).map((child, index) => {
      console.log("🚀 ~ renderContent ~ child:", child.tagName);

      if (child.tagName === "H1") {
        return (
          <Row key={index}>
            <Col>
              <h1 className="font-level-8" >{child.textContent}</h1>
            </Col>
          </Row>
        );
      }

      if (child.tagName === "H2") {
        return (
          <Row key={index} className="">
            <Col>
              <h1 className="font-level-7">{child.textContent}</h1>
            </Col>
          </Row>
        );
      }

      if (child.tagName === "P" && child.textContent.trim()) {
        return (
          <Row key={index}>
            <Col>
              <p
                className="country-paragraph-text mb-4"
                dangerouslySetInnerHTML={{
                  __html: child.innerHTML,
                }}
              />
            </Col>
          </Row>
        );
      }

      // Handle unordered lists (UL)
      if (child.tagName === "UL") {
        return (
          <Row key={index}>
            <Col>
              <ul
                className="country-paragraph-text"
                dangerouslySetInnerHTML={{
                  __html: child.innerHTML,
                }}
              />
            </Col>
          </Row>
        );
      }

      // Handle ordered lists (OL)
      if (child.tagName === "OL") {
        return (
          <Row key={index}>
            <Col>
              <ol
                className="country-paragraph-text"
                dangerouslySetInnerHTML={{
                  __html: child.innerHTML,
                }}
              />
            </Col>
          </Row>
        );
      }

      return null;
    });
  };
  return (
    <div>
      <div
        className="about-hero-banner"
        style={{
          "--banner-img": `url(${imageBaseApi + detailData?.media?.url})`,
          marginBottom: "5.5rem",
        }}
      >
        <SectionContainer>
          <BreadCrumb
            items={[
              { title: "HOME", link: "/" },
              { title: "ABOUT", link: "#" },
              { title: "WHO WE ARE" },
            ]}
            instituition={true}
          />
          <div className=" page-content text-start h-100 d-flex flex-column justify-content-center">
            <h1
              className="font-level-4"
              style={{ color: `${detailData?.bannerColor}` }}
            >
              {detailData?.bannerText}
            </h1>
          </div>
        </SectionContainer>
      </div>
      <SectionContainer>
        <Container>
          {contents && renderContent(contents[0])}

          <Row className="d-flex  align-items-start my-5">
            <Col lg={6} sm={12}>
              <img
                src={`${imageBaseApi}${detailData?.contentMedia?.url}`}
                className=" whoweare-img"
                alt=""
              />
            </Col>
            <Col lg={6} sm={12}>
              {" "}
              {contents && renderContent(contents[1])}
              {/* <p className='country-paragraph-text align-items-center'>Beyond counselling and admissions, KEF offers comprehensive <span className='fw-bold'>test preparation services </span> for IELTS, PTE, TOEFL, Duolingo, SAT, GRE, and GMAT. These programs are delivered by highly qualified and experienced instructors who focus on building strong language and reasoning foundations, exam confidence, and strategic readiness. Our preparation approach is structured, ethical, and outcome-focused — ensuring students are genuinely prepared for success.
              <br /> <br />
              What truly distinguishes KEF is our <span className='fw-bold'>student-first, process-driven approach</span>. We begin by understanding every student as an individual — analysing their strengths, weaknesses, academic history, and future aspirations. Only after developing a clear understanding of their profile do we guide them through study destinations, course options, institutions, and financial considerations. This ensures that every recommendation we provide is transparent, accurate, and tailored to the student’s real potential.</p> */}
            </Col>
          </Row>
          <div>{contents && renderContent(contents[2])}</div>
          {/* <Row >
            <Col style={{ marginTop: "3.9rem", marginBottom: "8.3rem" }}>
              <p className='country-paragraph-text m-0 '>Our team of certified professionals upholds the highest standards of ethics, transparency, and service excellence. At every stage, students receive honest advice, clear communication, and consistent support. We do not believe in shortcuts or generic COUNSELING — our commitment is to long-term outcomes built on trust and clarity.
                <br /> <br />
                <span className='font-level-8'>Vision</span> <br />
                To become a synonym for the <span className='fw-bold'>education–migration ecosystem.</span>
                <br /> <br />
                <span className='font-level-8'>Mission</span> <br />
                To empower study-abroad aspirants by providing <span className='fw-bold'>authentic and genuine counseling, effective test preparation classes, and reliable support services.</span>
                <br /> <br />
                <span className='font-level-8'>Values</span> <br />
                Integrity, Commitment, and Trust.
                <br /> <br />
                <span className='font-level-8'>Goal</span> <br />
                <span className='fw-bold'>Grow. Accelerate. Excel.</span>
                <br /> <br />
                <span className='font-level-8'>Objective</span> <br />
                We shall <span className='fw-bold'>GROW </span>every day by challenging ourselves, not others; <span className='fw-bold'>ACCELERATE </span>by competing with our own past performance, not that of others; and <span className='fw-bold'>EXCEL </span>by outperforming our own expectations rather than measuring ourselves against others.
                This philosophy drives our continuous improvement and reinforces our commitment to delivering ethical, student-centric, and future-focused guidance.
                <br /> <br />
                <span className='font-level-8'>Our Commitment</span> <br />
                At Kangaroo Education Foundation, we are professionally committed to delivering <span className='fw-bold'>authentic and genuine counseling</span>. With a dedicated and highly trained team supporting students at every stage, we ensure that the path to international education is not only well-informed, but also rooted in honesty, clarity, and genuine care. <br />
                KEF exists to bridge the gap between <span className='fw-bold'>talent and opportunity</span> — helping students realise their full potential and confidently take their next step toward a global future.</p></Col>
          </Row> */}
          <Row style={{ marginBottom: "22.6rem", marginTop:"4rem" }}>
            {detailData?.subDetails.map((item, index) => (
              <Col
                key={index}
                lg={4}
                sm={12}
                className="mb-4 d-flex align-items-stretch"
                style={{ height: "330px" }}
              >
                <div
                  className="stat-tile gap-4 border rounded-5 p-3 w-100 h-100 d-flex flex-column justify-content-end pb-4 ps-4"
                  style={{
                    backgroundColor: item.color,
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)";
                    e.currentTarget.style.transform = "scale(1.1)";
                    e.currentTarget.style.boxShadow =
                      "0 10px 30px rgba(0, 0, 0, 0.5)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  <img
                    src={`${imageBaseApi}${item?.media?.url}`}
                    fluid
                    className="tile-img"
                    alt=""
                    style={{
                      transition: "transform 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.1)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                  />
                  <div>
                    <h2 className="about-tile-heading ">{Number(item.textNumber)}+</h2>
                    <p
                      className="about-tile-subtext mt-4 lh-1"
                      dangerouslySetInnerHTML={{ __html: item.textDescription }}
                    ></p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </SectionContainer>
    </div>
  );
};

export default AboutLanding;
